export default __webpack_public_path__ + "static/media/oluseun_2.3cae4303.jpeg";